import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataService } from '../data.service';
import { CarrierLocalAgentsEntity } from 'src/app/shared/common-components/common-structure';

@Injectable({
  providedIn: 'root'
})
export class CarrierLocalAgentService extends DataService {

  constructor(http: HttpClient) {
    super(http);
  }

  /**
     * @description Retrieve all local agents of the Carier given carrieId
     * @param carrierId: carrierId of the carrier
     */
    getCarrierLocalAgentsByCarrierId(carrierId: string): Observable<any> {
    return this.http.get(this.apiUri + '/carrierlocalagents/' + carrierId + '/carrierid/');
  }

  /**
     * @description Retrieve all local agents of the Carier given carrieId
     * @param carrierId: carrierId of the carrier
     */
    getAllCarrierLocalAgentsByCarrierId(carrierId: string): Observable<any> {
      return this.http.get(this.apiUri + '/carrierlocalagents/' + carrierId + '/allstatus/');
    }

  /**
     * @description Retrieve local agent information based on scaccode
     * @param scaccode: scaccode of the selected local agent
     */
    getCarrierLocalAgentByAgentId(agentId: string): Observable<any> {
      return this.http.get(this.apiUri + '/carrierlocalagents/' + agentId + '/agentid/');
    }

    /**
     * @description Retrieve all local agents
     */
    getAllCarrierLocalAgents(): Observable<any> {
      return this.http.get(this.apiUri + '/carrierlocalagents' + '/allcarrierlocalagents');
    }

    /**
     * @description save local agents
     */
    saveCarrierLocalAgents(carrierLocalAgentsEntity: CarrierLocalAgentsEntity): Observable<any> {
      return this.http.post(this.apiUri + '/carrierlocalagents' + '/savecarrierlocalagent', carrierLocalAgentsEntity);
    }
}
